import moment from "moment";
import { Map } from "immutable";

import {
  POBReportMapper,
  HeliReportMapper,
  WorkScheduleReportMapper,
} from "features/planner/report/report.mappers";

import {
  ACTIONS,
  WORK_SCHEDULE_REPORT_TYPE,
  WORK_SCHEDULE_REPORT_FORM,
} from "features/planner/report/report.constants";
import { EMPTY_MAP, EMPTY_LIST } from "app/app.constants";

import {
  getWorkScheduleReportStartDate,
  getWorkScheduleReportEndDate,
} from "utils/report.util";
import {
  WorkScheduleOverrideMapper,
  EmployeeMapper,
} from "features/planner/planner.mappers";

const initialWorkScheduleReportType = WORK_SCHEDULE_REPORT_TYPE.MONTH;

const initialState = Map({
  pob: EMPTY_LIST,
  heli: EMPTY_MAP,
  workSchedule: Map({
    parameters: Map({
      [WORK_SCHEDULE_REPORT_FORM.YEAR]: moment().year(),
      [WORK_SCHEDULE_REPORT_FORM.MONTH]: moment().month(),
      [WORK_SCHEDULE_REPORT_FORM.TYPE]: initialWorkScheduleReportType,
      [WORK_SCHEDULE_REPORT_FORM.START_DATE]: getWorkScheduleReportStartDate(
        initialWorkScheduleReportType,
        moment(),
      ),
      [WORK_SCHEDULE_REPORT_FORM.END_DATE]: getWorkScheduleReportEndDate(
        initialWorkScheduleReportType,
        moment(),
      ),
    }),
  }),
  scheduleOverridesReport: Map({
    scheduleOverrides: EMPTY_MAP,
    employees: EMPTY_MAP,
  }),
});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_POB_REPORT: {
      if (error) return state;

      return state.set(
        "pob",
        Map(
          payload.map(installation => [
            installation.groupId.toString(),
            POBReportMapper.from(installation),
          ]),
        ),
      );
    }

    case ACTIONS.GET_HELI_REPORT: {
      if (error) return state;

      return state.setIn(
        ["heli", payload.groupId.toString()],
        HeliReportMapper.from(payload),
      );
    }

    case ACTIONS.GET_WORK_SCHEDULE_REPORT: {
      if (error) return state;

      return state.set("workSchedule", WorkScheduleReportMapper.from(payload));
    }

    case ACTIONS.UNLOAD_WORK_SCHEDULE_REPORT: {
      return initialState;
    }

    case ACTIONS.GET_SCHEDULE_OVERRIDES_REPORT: {
      if (error) return state;

      return state
        .setIn(
          ["scheduleOverridesReport", "scheduleOverrides"],
          Map(
            payload.scheduleOverrides.map(scheduleOverride => [
              scheduleOverride.workScheduleOverrideId.toString(),
              WorkScheduleOverrideMapper.from(scheduleOverride),
            ]),
          ),
        )
        .setIn(
          ["scheduleOverridesReport", "employees"],
          Map(
            payload.employees.map(employee => [
              employee.employeeId.toString(),
              EmployeeMapper.from(employee),
            ]),
          ),
        );
    }

    default:
      return state;
  }
};
